import { Routes, Route } from "react-router-dom";
import Locations from "./Locations";
import LocationCreateEdit from "./LocationCreateEdit";
import LocationDetails from "./LocationDetails";

const index = () => {
	return (
		<Routes>
			<Route index element={<Locations />} />
			<Route path='/create' element={<LocationCreateEdit />} />
			<Route path='/:id/edit' element={<LocationCreateEdit />} />
			<Route path='/:id/details' element={<LocationDetails />} />
		</Routes>
	);
};

export default index;
